module.exports = __webpack_public_path__ + "img/logo_seu.88342560.png";